import { createFileRoute } from '@tanstack/react-router'
import { BackupsOperations } from '@/features/backups'

type OperationsSearch = {
  tab?: 'overview' | 'jobs' | 'logs'
  approvalId?: number
  logSource?: string
  autoStart?: boolean
  demo?: string
  jobType?: string
  jobStatus?: string
  jobSearch?: string
  jobSort?: string
}

export const Route = createFileRoute(
  '/_authenticated/instances/$instanceId/operations'
)({
  validateSearch: (search: Record<string, unknown>): OperationsSearch => {
    const tab = search.tab
    const rawApprovalId =
      search.approvalId !== undefined && search.approvalId !== null
        ? Number(search.approvalId)
        : undefined
    const jobType = search.jobType
    const jobStatus = search.jobStatus
    const jobSearch = search.jobSearch
    const jobSort = search.jobSort
    const logSource = search.logSource
    const demo = search.demo
    const autoStart = search.autoStart

    return {
      tab:
        tab === 'overview' || tab === 'jobs' || tab === 'logs'
          ? tab
          : undefined,
      approvalId:
        typeof rawApprovalId === 'number' &&
        Number.isInteger(rawApprovalId) &&
        rawApprovalId > 0
          ? rawApprovalId
          : undefined,
      logSource:
        typeof logSource === 'string' && logSource.trim().length > 0
          ? logSource.trim().slice(0, 100)
          : undefined,
      autoStart:
        autoStart === true || autoStart === 'true' || autoStart === '1'
          ? true
          : undefined,
      demo:
        typeof demo === 'string' && demo.trim().length > 0
          ? demo.trim().slice(0, 100)
          : undefined,
      jobType:
        typeof jobType === 'string' && jobType.trim().length > 0
          ? jobType.trim()
          : undefined,
      jobStatus:
        typeof jobStatus === 'string' && jobStatus.trim().length > 0
          ? jobStatus.trim()
          : undefined,
      jobSearch: typeof jobSearch === 'string' ? jobSearch : undefined,
      jobSort:
        typeof jobSort === 'string' && jobSort.trim().length > 0
          ? jobSort.trim()
          : undefined,
    }
  },
  component: BackupsOperations,
})
